<div class="c-cms-form">
    <div class="form-flex">
        <div class="form-label">{{if field.required == 1}}<span class="form-required">*</span>{{/if}}{{field.displayName}}</div>
        <div class="form-value">
            <div class="form-row">
                <input type="text" class="form-control text-fieldName send-text-{{field.fieldName}}" data-actid=".send-text-{{field.fieldName}}" onchange="$sk.changeTEXT(this, '{{field.fieldName}}')" value="{{field.value}}">
            </div>
            {{if field.dirty && field.invalid}}
            <div class="form-error">{{field.validationMessage}}</div>
            {{/if}}
            {{if field.isSendSms == 1}}
            <div class="form-row form-flex send-code">
                <input type="text" class="form-control send-code-{{field.fieldName}}" data-actid=".send-code-{{field.fieldName}}" onchange="$sk.sendCodeInput(this, '{{field.fieldName}}')" value="{{field.verificationCode}}">
                <input type="button"  class="send-button j-send-{{field.fieldName}}"
                       value="{{field.sendCodeJson.time === 0 ? '获取验证码' : field.sendCodeJson.time + '秒'}}"
                       onclick="$sk.sendCode(this, '{{field.fieldName}}', 'customForm')" {{field.sendCodeJson.disabled ? 'disabled' : ''}}/>
            </div>
            {{if field.verificationCodeDirty && field.verificationCodeError}}
            <div class="form-error j-send-error-{{field.fieldName}}">请输入验证码</div>
            {{/if}}
            {{/if}}
        </div>
    </div>
</div>